import { h, Component } from 'preact'
import PropTypes from 'prop-types'
import imageExists from 'image-exists'

export default () => (Cmp) => {
  class ImageExists extends Component {
    constructor(props) {
      super(props)

      this.state = {
        src: this.props.src
      }
    }

    componentDidMount() {
      this.checkIfExists(this.props.src)
    }

    componentWillReceiveProps(newProps) {
      if (newProps.src !== this.props.src) {
        this.checkIfExists(newProps.src)
      }
    }

    checkIfExists(src) {
      if (!src) {
        this.setState({
          src: ''
        })
      } else {
        imageExists(src, (exists) => {
          this.setState({
            src: exists ? src : ''
          })
        })
      }
    }

    render() {
      const { src } = this.state
      const { fallbackSrc, ...rest } = this.props

      return (
        <Cmp {...rest} src={src || fallbackSrc} />
      )
    }
  }

  ImageExists.propTypes = {
    src: PropTypes.string,
    fallbackSrc: PropTypes.string
  }

  ImageExists.defaultProps = {
    src: '',
    fallbackSrc: ''
  }

  return ImageExists
}



// WEBPACK FOOTER //
// ./src/hocs/imageExists.js